// Event record we use to indicated that a teacher has seen welcome-back message.
export const WELCOME_BACK_EVENT_NAME = 'user-seen-welcome-back';
